import { useEffect, useState } from "react";
import {
    taxCountriesSorted,
    subscribeTaxRules,
    loadTaxRulesFromServer,
    currentTaxRulesVersion,
} from "./taxRules";

/**
 * React hook that keeps a component in sync with the current tax rules
 * table. Returns the sorted country list plus the version string. On
 * first render the baked-in fallback (or localStorage cache) is used;
 * once the server responds the component re-renders with fresh rules.
 */
export function useTaxCountries() {
    const [tick, setTick] = useState(0);

    useEffect(() => {
        // Nudge the fetcher — cheap no-op if already loaded/in-flight.
        loadTaxRulesFromServer();
        const unsub = subscribeTaxRules(() => setTick((t) => t + 1));
        return unsub;
    }, []);

    // `tick` isn't used in the return — its role is just to force a
    // re-render when the module-level rules table swaps. `taxCountriesSorted`
    // reads the current list on every call.
    return {
        countries: taxCountriesSorted(),
        version: currentTaxRulesVersion(),
        _tick: tick,
    };
}
